module.exports = __webpack_public_path__ + "static/media/Videos.5341a5fa.png";